import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  list: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  detail: { data: null, loading: false },
  thumb: { data: null, loading: false },
  axialTypes: { data: [], loading: false },
  illuminantTypes: { data: [], loading: false },
  ueDialog: { visible: false, loading: false, fullpath: '' },
  confirm: { title: '', content: '', name: '', visible: false, loading: false },
  searchParams: null,
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
